import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import ButtonComponent from "../ui/ButtonComponent";

const SubscriptionActivationGate = ({
  onActivate,
  onDismiss,
  hideDismiss = false,
  dismissing = false,
}) => {
  const canDismiss = !hideDismiss && typeof onDismiss === "function";

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        bgcolor: "background.default",
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 520,
          width: "100%",
          borderRadius: 3,
          boxShadow: 6,
          p: 4,
          bgcolor: "background.paper",
        }}
      >
        <Stack spacing={2.5} alignItems="center" textAlign="center">
          <Typography variant="h5" fontWeight={700}>
            Activate your Kinova subscription
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Your organization is almost ready. Activate your subscription to unlock
            events, documents, forms, and automation tools.
          </Typography>

          <Stack spacing={1.25} width="100%">
            <ButtonComponent
              label="Activate Subscription"
              size="large"
              onClick={onActivate}
            />

            {canDismiss ? (
              <ButtonComponent
                label="I’ll do this later"
                type="secondary"
                size="large"
                onClick={onDismiss}
                disabled={!!dismissing}
                isLoading={!!dismissing}
              />
            ) : null}
          </Stack>

          <Typography variant="caption" color="text.secondary">
            Secure checkout powered by Stripe
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default SubscriptionActivationGate;